/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import ContentFrame from '../../../applicationFrame/ContentFrame';
import { ScrollAwareContext, ScrollAwareScroller, ScrollAwareAppNavStep } from '../../../components/ScrollAware';
import { AppHeaderScrollableText } from '../../../components/appNav/AppHeaderScrollable';

import RouteNames from '../../RouteNames';
import ContentWrapper from '../../../components/ContentWrapper';
import PhoneInput from '../../../components/PhoneInput';

import { Card, Spacer, Text } from '../../../../bphComponents/bundle';
import { ConnectedGrayPrivacyCard } from '../../../components/card/PrivacyCard';
import { PolicyName } from '../../../../models/PolicyModel';

class MfaSetMobileNumber extends React.Component {

  constructor(props) {
    super(props);

    this.handleMobileNumberChange = this.handleMobileNumberChange.bind(this);
    this.submitMobileNumber = this.submitMobileNumber.bind(this);
    this.clearValue = this.clearValue.bind(this);

    this.state = {
      displayNumber: this.props.mobileNumber,
      submitted: false,
      isInvalid: false,
      errorMessage: '',
      mobileNumberSubmitted: false,
    };
  }

  UNSAFE_componentWillMount() {
    this.props.loadInitialData();
  }

  submitMobileNumber(event) {
    event.preventDefault();

    if (this.state.displayNumber === '') {
      this.setState({
        submitted: true,
      });
      return;
    } else if (this.state.isInvalid) {
      this.setState({
        errorMessage: <FormattedMessage id="error.api-users.400-invalid-mobile-number.message" />,
        submitted: true,
      });
      return;
    }

    this.setState({
      submitted: true,
    });

    this.props.submitMobileNumber(() => {
      this.props.goToVerify();
    });
  }

  handleMobileNumberChange(data) {
    const { formattedNumber, isValid, countryCode } = data;

    this.setState({
      displayNumber: formattedNumber,
      isInvalid: !isValid,
    });

    this.props.onChangeMobileNumber(formattedNumber, isValid);
    this.props.onChangeCountry(countryCode);
  }

  clearValue() {
    this.setState({
      displayNumber: '',
      isInvalid: true,
      errorMessage: '',
      submitted: false,
    });
  }

  render() {
    if (!this.props.mfaEnableIsInitated) {
      return <Redirect to={RouteNames.accountSettings()} />;
    } else {
      return (
        <div>
          <ScrollAwareContext>
            <ScrollAwareAppNavStep
              submitDisabled={this.state.isInvalid}
              cancel={this.props.goBack}
              next={this.submitMobileNumber}
              onDisabledClick={this.submitMobileNumber}
              color="white"
            />

            <ContentFrame>
              <ScrollAwareScroller>
                <AppHeaderScrollableText
                  id="settings2FA.turnOnTitle.text"
                />
                <ContentWrapper>

                  <ConnectedGrayPrivacyCard
                    name={PolicyName.MFA_PHONE_NUMBER}
                    subTitle="privacy.privacyBlock.2faPhoneNumber.teaser"
                    onWithdrawConsent={null}
                  />

                  <Card.CardShape>
                    <Card.CardContent>
                      <Text.TextSubhead className="font-color-gsMedDark">
                        <FormattedMessage id="settings2FA.explanation.message.text" />
                      </Text.TextSubhead>

                      <Spacer.Height18 />

                      <form onSubmit={this.submitMobileNumber}>
                        <PhoneInput
                          name="mobileNumber"
                          label={<FormattedMessage id="settings2FA.phone.field.label" />}
                          countryCode={this.props.country}
                          phoneNumber={this.state.displayNumber}
                          ignoreValidation={!this.state.submitted}
                          autoFocus={true}
                          preventFloating={true}
                          isClearable={true}
                          onChange={this.handleMobileNumberChange}
                          countryLabel={<FormattedMessage id="settings2FA.countryCode.field.label" />}
                          className="font-color-profile"
                          invalidHint={<FormattedMessage id="error.api-users.400-invalid-mobile-number.message" />}
                        />
                      </form>
                    </Card.CardContent>
                  </Card.CardShape>
                </ContentWrapper>
              </ScrollAwareScroller>
            </ContentFrame>
          </ScrollAwareContext>
        </div>
      );
    }
  }
}
MfaSetMobileNumber.propTypes = {
  mfaEnableIsInitated: PropTypes.bool,
  mobileNumber: PropTypes.string,
  country: PropTypes.string,
  countryOptions: PropTypes.array,
  submitMobileNumber: PropTypes.func,
  loadInitialData: PropTypes.func,
  onChangeMobileNumber: PropTypes.func,
  onChangeCountry: PropTypes.func,
  goBack: PropTypes.func,
  goToVerify: PropTypes.func,
};

export default MfaSetMobileNumber;
